module.exports = __webpack_public_path__ + "static/media/comparison1.7ddd2a29.png";